import axios from '@/http/axios';

export default {
  fetch: (oid, config: any = {}) => {
    return axios.get(`/businesses/${oid}`, config);
  },
  fetchList: (config: any = {}) => {
    return axios.get(`/businesses`, config);
  },
  create: (config: any = {}) => {
    return axios.post(`/businesses`, config);
  },
  update: (oid, config: any = {}) => {
    return axios.put(`/businesses/${oid}`, config);
  },
  creditCheck: (oid, config: any = {}) => {
    return axios.put(`/businesses/${oid}/credit-check`, config);
  },
  paymentMethods: (oid) => {
    return axios.get(`/businesses/${oid}/payment-methods`);
  },
  serviceItemTotalAvailableQuantity: (oid) => {
    return axios.get(`/businesses/${oid}/service-items`);
  },
  creditLevel: (oid, config: any = {}) => {
    return axios.put(`/businesses/${oid}/credit-level`, config);
  },
  all: (config: any = {}) => {
    return axios.get(`/businesses/all`, config);
  },
  users: (oid, config: any = {}) => {
    return axios.get(`/businesses/${oid}/users`, config);
  },
  validateEmail: (businessOid, email, id = null) => {
    return axios.get(`/businesses/${businessOid}/validate-email`, {
      params: { email, id },
    });
  },
  addUser: (businessOid, config: any = {}) => {
    return axios.post(`/businesses/${businessOid}/users`, config);
  },
  updateUser: (businessOid, userId, config: any = {}) => {
    return axios.put(`/businesses/${businessOid}/users/${userId}`, config);
  },
  deleteUser: (businessOid, userId) => {
    return axios.delete(`/businesses/${businessOid}/users/${userId}`);
  },
  referralBusiness: (businessOid, config: any = {}) => {
    return axios.put(`/businesses/${businessOid}/referral-business`, config);
  },
  validatePaymentMethod: (businessOid, { pm_id }) => {
    return axios.get(`/businesses/${businessOid}/validate-payment-method`, {
      params: { pm_id },
    });
  },
  deletePaymentMethod: (businessOid, config) => {
    return axios.delete(
      `/businesses/${businessOid}/delete-payment-method`,
      config
    );
  },
};
